import React, { useContext, useEffect, useState } from "react";

import { ContactContext, SocialDataContext as Context } from "./index";
import { toast } from "react-toastify";
import { alertSuccess } from "../../../Shared/Utils/alertMessages.js";
import { createContactSocialDataApi } from "../Api/CreateContact.js";
import { updateContactSocialDataApi } from "../Api/UpdateContact.js";
import { showContactSocialDataApi } from "../Api/ShowContact.js";
import {
  alertToastErrorFromResponse,
  getErrorsArrayMessageFromHtttpResponse,
} from "../../../Shared/Utils/errorUtils.js";

const SocialDataProvider = (props) => {
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);

  //get all item data
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await showContactSocialDataApi(id);

      let data = response.data;
      if (response.result === "success") {
        setItem(data);
      } else {
        setItem({});

        alertToastErrorFromResponse(
          "Error obteniendo datos del contacto",
          response
        );
      }
    } catch (error) {
      toast.error("Error desconocido obteniendo datos del contacto !", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    let response = await createContactSocialDataApi(data);

    if (response?.result && response?.result == "success") {
      setApiErrors([]);
      setItem(response.data);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  //edit item
  const updateItem = async (data, id) => {
    let response = await updateContactSocialDataApi(data, id);

    if (response?.result && response?.result == "success") {
      //setSuccessUpdated(true);
      getItem(id)
      
      setApiErrors([]);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };

  return (
    <Context.Provider
      value={{
        ...props,

        createItem,
        updateItem,
        setLoading,
        apiErrors,
        setItem,
        item,
        loading,
        handleEdit,
        getItem,
        setApiErrors,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default SocialDataProvider;
